// Single source of truth for which Pioneer DJ / AlphaTheta players can play
// FLAC files. Rendered by both the About tab reference and the Compatibility
// tab "Depends" popover so the two can never drift apart again.
//
// Verified Aug 2026 against official spec pages / AlphaTheta support:
// - CDJ-3000, CDJ-2000NXS2, CDJ-TOUR1, OPUS-QUAD: FLAC + ALAC up to 96 kHz/24-bit
// - XDJ-RX3, XDJ-1000MK2: FLAC + ALAC up to 48 kHz/24-bit
// - XDJ-XZ: FLAC only (no ALAC), 44.1/48 kHz, requires firmware 1.10+ (Mar 2020)
// - XDJ-AZ, OMNIS-DUO: FLAC supported since launch
// - XDJ-RR: NO native FLAC — only as a rekordbox Performance-mode controller

export const FLAC_SUPPORT_TIERS = [
    { spec: 'up to 96 kHz / 24-bit', models: ['CDJ-3000', 'CDJ-2000NXS2', 'CDJ-TOUR1', 'OPUS-QUAD'] },
    { spec: 'up to 48 kHz / 24-bit', models: ['XDJ-RX3', 'XDJ-1000MK2'] },
    { spec: '44.1 / 48 kHz · firmware 1.10+', models: ['XDJ-XZ'] },
    { spec: null, models: ['XDJ-AZ', 'OMNIS-DUO'] },
];

export const FLAC_UNSUPPORTED_MODELS = [
    'CDJ-2000NXS', 'CDJ-2000', 'CDJ-900NXS', 'CDJ-900', 'CDJ-850',
    'XDJ-1000', 'XDJ-700', 'XDJ-RX', 'XDJ-RX2', 'XDJ-RR',
];

// Flat list for prose rendering (About tab).
export const FLAC_SUPPORTED_MODELS = FLAC_SUPPORT_TIERS.flatMap(({ spec, models }) =>
    models.map((model) => ({ model, spec })));

// One-line summary for native title tooltips.
export const FLAC_DEPENDS_SUMMARY =
    'FLAC plays on newer players (CDJ-3000, CDJ-2000NXS2, XDJ-RX3, XDJ-XZ…) '
    + 'but fails with E-8305 on older gear (CDJ-2000NXS, XDJ-RX2, XDJ-RR…)';
